import React, { useEffect, useState } from 'react'
import _cx from 'classnames/bind'
import JsonViewer from '../../elementals/jsonViewer'
import Animate from '../../elementals/animate'
import useIsMounted from '../../../hooks/useIsMounted'
import CardContainer from '../../elementals/cardContainer'
import { ColorNames } from '../../../constants/colorVars'
import type { CognitionEvaluationGroupMessage } from '@adc/sdk/types'
import cls from './styles.scss'
const cx = _cx.bind(cls)

export interface CognitionObjectMessageProps {
  message: CognitionEvaluationGroupMessage
  index: number
  onCopy?: (content: string) => void
  isVisible?: boolean
  elmId?: string
}

const CognitionObjectMessage: React.FC<CognitionObjectMessageProps> = ({
  message,
  index,
  onCopy,
  isVisible = true,
  elmId = 'cognition-message',
}) => {
  const [ReactJson, setReactJson] =
    useState<React.ComponentType<unknown> | null>(null)

  // @ts-ignore next
  const isMounted = useIsMounted() // eslint-disable-line
  useEffect(() => {
    if (!isMounted || typeof window === 'undefined') return

    const loadReactJson = () => {
      try {
        // eslint-disable-next-line
        const component = require('react-json-view')
          .default as React.ComponentType<unknown | null> // eslint-disable-line
        setReactJson(() => component)
      } catch (error) {
        console.error('Failed to load react-json-view:', error)
      }
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    loadReactJson()
  }, [isMounted])

  const messageWithoutObject = { ...message }
  // @ts-ignore next
  delete messageWithoutObject.object

  return (
    <Animate.FadeInOut
      key={`${message.sequence}-other`}
      isVisible={isVisible}
      duration={500}
    >
      <CardContainer
        backgroundColor={ColorNames.OffWhite}
        padding='none'
        borderRadius='medium'
        className={cx('message', 'json')}
        elmId={`${elmId}_container_${index}`}
      >
        <JsonViewer
          data={messageWithoutObject}
          classNames={{
            value: cx('json-value'),
            container: cx('json-node-container'),
          }}
          elmId={`${elmId}_json_viewer_${index}`}
        />
        {ReactJson ? (
          <ReactJson
            // @ts-ignore next
            style={{ fontSize: 14, padding: 18 }}
            name={false}
            // @ts-ignore next
            src={message.object || {}} // eslint-disable-line
            displayDataTypes={false}
            // @ts-ignore next
            enableClipboard={copy => onCopy && onCopy(JSON.stringify(copy))}
          />
        ) : (
          <p>Loading...</p>
        )}
      </CardContainer>
    </Animate.FadeInOut>
  )
}

export default CognitionObjectMessage
